const Filter = require('bad-words');
export const filter = new Filter();

filter.addWords('arsehole');

export default filter;
